import {IDivHostedAppInitParameters, IControlCenterBaseSpecificParams} from '@sparkware/uc-sdk-core';
import {IServiceFactoryExtended} from '../../../../service-factory-extended.interface';
import {Enviroments} from '@sparkware/uc-sdk-core/lib/apps/app-enums';
import {OPEN_SAFEZONE_SOURCE, OPEN_SAFEZONE_SOURCE_VALUES} from '../../../../safezone/safezone.service.interface';

export function getInitAppParamsForControlCenter(initParams: IDivHostedAppInitParameters, services: IServiceFactoryExtended): IDivHostedAppInitParameters {
    initParams.applicationContext.launchInfo.appSpecificParameters = getAppSpecificParamsForControlCenter(initParams.applicationContext.launchInfo.appSpecificParameters, services);

    // The env property should be sent for all applications and setting it should be in CasinofiedApplicationBase (casinofied-application-base.ts) nethod _getAppInitCommonParams
    // But because we did not sent it to other applications and we don't have the exact values to send, we only send it to control center
    initParams["env"] = services.configuration.startupConfiguration.sdk.config.ExtraProperties.env as Enviroments;

    return initParams;
}

export function getAppSpecificParamsForControlCenter<T extends IControlCenterBaseSpecificParams>(appSpecificParameters: T, services: IServiceFactoryExtended) {
    /**
     * When we open control center full or mini the source is set to a value OPEN_SAFEZONE_SOURCE_VALUES.LOBBY or OPEN_SAFEZONE_SOURCE_VALUES.USER_AREA
     * So we have to "translate" this value using OPEN_SAFEZONE_SOURCE put by safezone in window:
     * services.window.getGlobalProperty(OPEN_SAFEZONE_SOURCE)[initialSource]
     * BUT !!!! when control center full is opened from mini widget using the open-control-center-full.action-handler.ts the source in the payload is
     * already translated so if we try to translate it again we'll get undefined and the control center won't open
     */
    let initialSource = appSpecificParameters?.source || OPEN_SAFEZONE_SOURCE_VALUES.LOBBY;
    let source: string;
    let sourcesEnum = services.window.getGlobalProperty(OPEN_SAFEZONE_SOURCE);
    if (sourcesEnum && sourcesEnum[initialSource]) {
        source = sourcesEnum[initialSource];
    }
    if(!source){
        source = "lobby";
    }

    return {
        clientPlatform: parseInt(services.sdk.getSkin().getClientPlatform()),
        ...appSpecificParameters,
        source
    };

}
